import BaseModel from './BaseModel'

export default class Dealer extends BaseModel {
  // ... Dealer-specific methods or overrides ...
}
